import { render, staticRenderFns } from "./GenericTemplate.vue?vue&type=template&id=12f83df8&"
import script from "./GenericTemplate.vue?vue&type=script&lang=js&"
export * from "./GenericTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GenericTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports